<div class="sp-dialog__max-width-m sp-dialog__min-width">
    <div class="sp-width__full sp-row__end">
        <button (click)="onCloseClick()" mat-icon-button class="sp-icon__button sp-icon__button-accent">
            <mat-icon> clear </mat-icon>
        </button>
    </div>

    <div class="sp-padding__x2">
        <h3>{{ 'BUYERS.EDIT_IBAN_TITLE' | translate }}</h3>

        <div *ngIf="is_sources_list_running" class="sp-column__center sp-width__full sp-padding__x2">
            <mat-spinner color="accent" diameter="40"></mat-spinner>
            <p class="sp-color__accent sp-text__center sp-margin__top">Loading...</p>
        </div>

        <div *ngIf="!is_sources_list_running">
            <mat-form-field
                class="sp-width__full sp-form-field sp-form-field__primary-light sp-form-field__placeholder-s sp-margin__vert-x2"
                appearance="fill" color="accent">
                <mat-label>{{ 'BUYERS.EDIT_IBAN_LABEL' | translate }}</mat-label>
                <input matInput [value]="iban" (input)="onIbanInput($any($event.target).value)"
                    [placeholder]="'BUYERS.EDIT_IBAN_PLACEHOLDER' | translate" />
                <mat-error *ngIf="hasIbanFormatError()">
                    {{ 'ERROR.IBAN_FORMAT' | translate }}
                </mat-error>
            </mat-form-field>

            <app-shared-button class="sp-width__full" [button_class]="'sp-button__main'"
                [spinner_class]="'sp-spinner__main'" [is_disabled]="!canSave()" [is_spinner_visible]="is_save_running"
                [cta]="'GENERAL.CONFIRM_CTA'" (button_click)="onConfirmClick()"></app-shared-button>
        </div>
    </div>
</div>